<mat-dialog-content class="product-dialog-content">
    <div class="product-layout">
        <!-- =====================================================
             IMAGEN
             ===================================================== -->
        <section class="product-image-section">
            <div class="product-image-wrapper">
                <img class="product-image" [src]="defImgProd" [defaultImage]="defImgProd"
                    [alt]="product.descripcionProducto">
            </div>
        </section>
        <!-- =====================================================
             INFORMACIÓN DEL PRODUCTO
             ===================================================== -->
        <section class="product-info-section">
            <!-- CERRAR -->
            <button class="product-dialog-close" mat-dialog-close type="button" aria-label="Cerrar">
                <mat-icon>close</mat-icon>
            </button>
            <!-- CATEGORÍA -->
            <span class="product-category">
                {{ line?.descripcion }}
            </span>
            <!-- NOMBRE -->
            <h1 class="product-name">
                {{ baseData.productoAgrupador }}
            </h1>
            <!-- DESCRIPCIÓN -->
            <p class="product-description">
                {{ baseData.descripcionMkt }}
            </p>
            <!-- PRECIO -->
            <div class="product-price">
                {{ price | currency:'USD':'symbol':'1.0-0' }}
            </div>
            <!-- CANTIDAD + CARRITO -->
            <div class="product-purchase-row">
                <div class="quantity-section">
                    <span class="quantity-label">
                        CANTIDAD
                    </span>
                    <div class="quantity-control">
                        <button type="button" class="quantity-button" aria-label="Disminuir cantidad"
                            (click)="changeQty('restar')" [disabled]="price <= 0">
                            <mat-icon>
                                remove
                            </mat-icon>
                        </button>
                        <div class="quantity-value">
                            {{ qty }}
                        </div>
                        <button type="button" class="quantity-button" aria-label="Aumentar cantidad"
                            (click)="changeQty('sumar')" [disabled]="price <= 0">
                            <mat-icon>
                                add
                            </mat-icon>
                        </button>
                    </div>
                </div>
                <button class="product-add-button" mat-raised-button type="button" (click)="addCart()"
                    [disabled]="price <= 0">
                    <mat-icon>
                        shopping_cart
                    </mat-icon>
                    Agregar al carrito
                </button>
            </div>
            <!-- =================================================
                 PRESENTACIONES
                 ================================================= -->
            <div class="product-sizes" *ngIf="productsFullData.length > 1">
                <span class="product-section-label">
                    PRESENTACIÓN
                </span>
                <mat-button-toggle-group class="product-size-group" aria-label="Tamaños">
                    <mat-button-toggle *ngFor="let size of productsFullData" class="product-size-option"
                        [value]="size.idProducto" [disabled]="size.disabled"
                        [checked]="product.idProducto === size.idProducto" (click)="changeSelectedSize(size)">
                        <span class="product-size-option__text">
                            {{
                            size.descripcionProducto
                            ? size.descripcionProducto
                            : size.presentacion
                            }}
                        </span>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <!-- =================================================
                 RENDIMIENTO
                 ================================================= -->
            <div class="product-portions">
                <div class="product-portions-icon">
                    <mat-icon>
                        groups
                    </mat-icon>
                </div>
                <div>
                    <span class="product-section-label">
                        RENDIMIENTO
                    </span>
                    <p>
                        Para {{ product.porciones }} personas
                    </p>
                </div>
            </div>
            <p class="product-note">
                Precio sujeto a disponibilidad en sucursal.
            </p>
        </section>
    </div>
</mat-dialog-content>